import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import CompanyForm from "@/pages/medewerkers/$userId/zakelijke_gegevens/CompanyForm"
import { createFileRoute, useRouter } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/zakelijke_gegevens/invullen/")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const { data } = useCurrentUserSuspenseQuery()

  const handleNavigate = () => {
    router.navigate({
      to: "/profiel/zakelijke_gegevens",
      replace: true,
    })
  }

  return (
    <CompanyForm
      userId={Number(data?.data.userId)}
      handleNavigate={handleNavigate}
    />
  )
}
